import { useState, useCallback } from 'react';

/**
 * Hook for managing left panel state
 *
 * Provides open/close state and handlers for controlling a left panel drawer.
 * Similar pattern to modal/dialog state management.
 */
export const useLeftPanelState = (initialOpen = false) => {
	const [isOpen, setIsOpen] = useState(initialOpen);

	const open = useCallback(() => {
		setIsOpen(true);
	}, []);

	const close = useCallback(() => {
		setIsOpen(false);
	}, []);

	const toggle = useCallback(() => {
		setIsOpen((prev) => !prev);
	}, []);

	const onOpenChange = useCallback((state: { open: boolean }) => {
		setIsOpen(state.open);
	}, []);

	return {
		isOpen,
		open,
		close,
		toggle,
		onOpenChange,
	};
};
